// Cruce del catálogo contra las ventas de la tienda (o las del vendedor si su rol no puede leer las
// de la tienda) para la pestaña «Ventas hoy» del detalle.
import { daysSinceMx } from '@/lib/dateHelpers';
import { saleHasSku, skuSoldCents } from '@/api/services/retail-wizard/soldAmount';
import type { RecentSale } from '../../api/usePortal';

/** Ventana de la pestaña, en días: el mock mira los últimos 7. */
export const RECENT_WINDOW_DAYS = 7;

/** Aviso cuando el rol no puede leer las ventas de la tienda y se muestran solo las propias. */
export const OWN_SALES_ONLY_NOTE =
    'Son tus ventas, no las de toda la tienda: tu rol no puede leer las de tus compañeros.';

/** Ventas del SKU abierto, ya partidas en las dos secciones de la pestaña. */
export interface SkuSalesFacts {
    today: RecentSale[];
    recent: RecentSale[];
    /** Lo vendido del SKU en la ventana (DEC-46). `null` si no hubo ventas. */
    recentVolumeCents: number | null;
}

/** Parte las ventas del SKU en «hoy» y «últimos 7 días», de la más reciente a la más vieja. */
export function skuSalesFacts(
    sku: string,
    sales: RecentSale[],
    windowDays = RECENT_WINDOW_DAYS,
): SkuSalesFacts {
    const ofSku = sales
        .filter((sale) => saleHasSku(sale, sku))
        .sort((a, b) => b.soldAt.localeCompare(a.soldAt));
    const recent = ofSku.filter((sale) => daysSinceMx(sale.soldAt) < windowDays);

    return {
        today: ofSku.filter((sale) => sale.today),
        recent,
        recentVolumeCents:
            recent.length === 0
                ? null
                : recent.reduce((sum, sale) => sum + skuSoldCents(sale, sku), 0),
    };
}
